<simpayx-profile-options></simpayx-profile-options>
<div class="ion-page" id="main-content">
  <!-- <ion-buttons slot="start">
    <ion-menu-button>
      <ion-icon name="person-circle-outline"></ion-icon>
    </ion-menu-button>
  </ion-buttons>
  <ion-title>Simpayx</ion-title> -->
</div>
